import { StyleSheet } from "react-native";
import { ALIGN, DISPLAY, FLEX_DIRECTION } from "@lookiero/aurora";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderWidth1, space4 } = theme();

  return StyleSheet.create({
    pricePrice: {
      textAlign: ALIGN.RIGHT,
    },
    priceTotalLine: {
      borderTopWidth: borderWidth1,
      display: DISPLAY.FLEX,
      flexDirection: FLEX_DIRECTION.ROW,
      justifyContent: "space-between",
      paddingTop: space4,
    },
  });
};

export { style };
